module.exports = __webpack_public_path__ + "img/Stortingsmelding_Skolestart_i_Oslo.e59d01d3.jpg";